import { Component, Input, OnInit, Output, EventEmitter, ViewEncapsulation, ViewChild, ElementRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { RulesService } from 'app/services/audit/rules.service';
import { Calendar, MessageService, SelectItem } from 'primeng/primeng';
import { ActivatedRoute } from '@angular/router';
import { AuditActionForm } from 'app/views/audit/models/audit-action.model';
import { AuditRuleDtl, AuditRuleObject, AuditRulesType, JsonSchema } from 'app/views/audit/models/audit-event.model';
import { AcmTypeHasReasonService } from 'app/services/loyalty/acm-type-has-reason.service';
import { Acm } from 'app/models/loyalty-acm.model';
import { Moment } from 'moment';
import * as moment from 'moment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Campaign3KontableComponent } from 'app/views/campaign-3/components/campaign-3-kontable/campaign-3-kontable.component';
import { AcmTypehasReason } from 'app/models/loyalty-acm-type.model';
import { RulesDtlService } from 'app/services/audit/rulesdtl.service';
import { KoncentroValidators } from 'app/modules/UIKit/validators/koncentro-validators';
import { FormFields } from 'app/views/campaign-3/components/form-fields/form-fields.component';

@Component({
  selector: 'app-audit-new-action',
  templateUrl: './audit-new-action.component.html',
  styleUrls: ['./audit-new-action.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AuditNewActionComponent implements OnInit {
  ruleDtlIdCombo: AuditRuleDtl = new AuditRuleDtl();
  errors: boolean = false;
  @Input() ui_mode: string = this.rulesService.ui_modes.CREATE;
  @Input() formSchema: any;
  @Input() readOnly: boolean = false;
  @Input() language: string = "it";
  @Input() dateFormat: string = "dd/MM/yyyy";
  @Input() schemaMode: string = this.rulesService.schema_modes.CREATE;
  @Input() clusterOption: SelectItem[];
  @Input() clusterOptionActive: SelectItem[];
  @Input() acmList: SelectItem[];
  @Input() acmListFull: Array<Acm>;
  @Input() backButton: boolean = true;
  @Input() isPopUp: boolean;
  @Input() auditRuleObject: AuditRuleObject;
  @Output() forwardButtonClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output() enableConfirmButton: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() formSchemaChanged: EventEmitter<JsonSchema> = new EventEmitter<JsonSchema>();
  @Output() actionChanged: EventEmitter<string> = new EventEmitter<string>();
  @Output() closePopUp: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('descr_rule') descr_rule: ElementRef;
  @ViewChild('date_start') date_start: Calendar;
  @ViewChild('date_end') date_end: Calendar;
  @ViewChild('cluster') cluster: FormFields;
  @ViewChild('cluster_add') cluster_add: FormFields;
  @ViewChild('cluster_delete') cluster_delete: FormFields;
  @ViewChild('kncRest') kncRest: FormFields;
  @ViewChild('push') push: FormFields;
  @ViewChild('cluster_start') cluster_start: FormFields;
  @ViewChild('cluster_end') cluster_end: FormFields;
  @ViewChild('acm') acm: FormFields;
  @ViewChild('acm_val') acm_val: FormFields;
  @ViewChild('acm_reason') acm_reason: FormFields;
  @ViewChild('amazon') amazon: FormFields;
  @ViewChild('magnews') magnews: FormFields;
  @ViewChild('kafka') kafka: FormFields;
  @ViewChild('actionListTable') actionListTable: Campaign3KontableComponent;
  @ViewChild('challenge_id') challenge_id: FormFields;
  @ViewChild('challenge_description') challenge_description: FormFields;
  @ViewChild('start_date') start_date: FormFields;
  @ViewChild('end_date') end_date: FormFields;
  @Input() listReasonsFull: Array<AcmTypehasReason> = [];
  @Input() auditRuleDtEditlId: number;
  formGroup: FormGroup;
  amazonOption: SelectItem[] = [];
  magnewsOption: SelectItem[] = [];
  pushOption: SelectItem[] = [];
  kncRestOption: SelectItem[] = [];

  kafkaOption: SelectItem[] = [];
  @Input() listReasonsFiltered: SelectItem[] = [];
  actionForm: AuditActionForm = new AuditActionForm();
  selectedRuleAction: any = null;
  @Output() conditionObjectChanged: EventEmitter<AuditRuleObject> = new EventEmitter<AuditRuleObject>();//funziona per i dettagli

  @Input() ruleId: number;
  fieldModel = {
    cluster: null,
    cluster_add: false,
    cluster_delete: false,
    cluster_start: null,
    cluster_end: null,
    acm: null,
    acm_val: null,
    acm_reason: null,
    amazon: null,
    kafka: null,
    magnews: null,
    push: null,
    kncRest: null,
    date_start: null,
    date_end: null,
    challenge_id: null,
    challenge_description: null,
    start_date: null,
    end_date: null,
  }

  ready = {
    form: false
  }

  show = {
    amazon: false,
    form: false,
    cluster: false,
    acm: false,
    kafka: false,
    magnews: false,
    push: false,
    kncRest: false,
    custMovement: false
  }

  @Input() actionsType: Array<AuditRulesType>;
  @Input() actionsTypeCombo: SelectItem[];

  constructor(
    private srvTranslate: TranslateService,
    private srvMessage: MessageService,
    public rulesService: RulesService,
    public rulesServiceDtl: RulesDtlService,
    private translate: TranslateService,
    private acmTypeHasReasonService: AcmTypeHasReasonService,
    private fb: FormBuilder
  ) {
  }

  ngOnInit() {
    this.initForm();
    this.show.form = true;
    if (this.auditRuleDtEditlId && this.auditRuleDtEditlId > 0) {
      this.ui_mode = this.rulesService.ui_modes.EDIT
      this.setFormField();
    } else {
      this.ui_mode = this.rulesService.ui_modes.CREATE
      this.selectedRuleAction = null;
      this.fieldModel.acm = null;
      this.fieldModel.acm_val = null;
      this.fieldModel.acm_reason = null;
      this.fieldModel.amazon = null;
      this.fieldModel.kafka = null;
      this.fieldModel.magnews = null;
      this.fieldModel.cluster = null;
      this.fieldModel.cluster_start = null;
      this.fieldModel.cluster_end = null;
      this.fieldModel.date_end = null;
      this.fieldModel.date_start = null;
      this.fieldModel.challenge_id = null;
      this.fieldModel.challenge_description = null;
      this.fieldModel.start_date = null;
      this.fieldModel.end_date = null;
    }

  }

  onClickExists() {
    this.enableConfirmButton.emit(true);

  }
  performValidationAction(): boolean {

    this.actionForm.valid = true;
    if (
      KoncentroValidators.isEmptyInputValue(this.descr_rule.nativeElement.value) ||
      KoncentroValidators.isEmptyInputValue(this.selectedRuleAction) ||
      KoncentroValidators.isEmptyInputValue(this.formGroup.controls.date_end.value) ||
      KoncentroValidators.isEmptyInputValue(this.formGroup.controls.date_start.value)
    ) {
      this.actionForm.valid = false;
      this.srvMessage.add({
        severity: 'error',
        summary: this.translate.instant('common.error'),
        detail: this.translate.instant('common.empty_fields')
      });
    }
    if (this.show.acm) {
      this.acm.performValidation();
      this.acm_val.performValidation();
      this.acm_reason ? this.acm_reason.performValidation() : null;
      if (!this.acm.valid ||
        !this.acm_reason.valid ||
        !this.acm_val.valid) {
        this.actionForm.valid = false;
      }
    }

    if (this.show.cluster) {
      this.cluster.performValidation();
      this.cluster_add.performValidation();
      this.cluster_delete.performValidation();
      this.cluster_end.performValidation();
      this.cluster_start.performValidation();
      if (!this.cluster.valid ||
        !this.cluster_add.valid ||
        !this.cluster_delete.valid ||
        !this.cluster_end.valid ||
        !this.cluster_start.valid) {
        this.actionForm.valid = false;
      }
      const clusterItem = this.fieldModel.cluster as any;
      if (clusterItem && clusterItem.date_end) {
        const dateEnd = new Date(clusterItem.date_end);
        dateEnd.setHours(23, 59, 59, 999);
        if (dateEnd < new Date()) {
          this.actionForm.valid = false;
          this.srvMessage.add({
            severity: 'error',
            summary: this.translate.instant('common.error'),
            detail: this.translate.instant('audit.cluster_expired')
          });
        }
      }
    }

    if (this.show.amazon) {
      this.amazon.performValidation();
      if (!this.amazon.valid) {
        this.actionForm.valid = false;
      }
    }

    if (this.show.kafka) {
      this.kafka.performValidation();
      if (!this.kafka.valid) {
        this.actionForm.valid = false;
      }
    }

    if (this.show.magnews) {
      this.magnews.performValidation();
      if (!this.magnews.valid) {
        this.actionForm.valid = false;
      }
    }

    if (this.show.kncRest) {
      this.kncRest.performValidation();
      if (!this.kncRest.valid) {
        this.actionForm.valid = false;
      }
      this.cluster.performValidation();
      this.cluster_add.performValidation();
      this.cluster_delete.performValidation();
      this.cluster_end.performValidation();
      this.cluster_start.performValidation();
      if (!this.cluster.valid ||
        !this.cluster_add.valid ||
        !this.cluster_delete.valid ||
        !this.cluster_end.valid ||
        !this.cluster_start.valid) {
        this.actionForm.valid = false;
      }
    }

    if (this.show.push) {
      this.push.performValidation();
      if (!this.push.valid) {
        this.actionForm.valid = false;
      }
    }

    if (this.show.custMovement) {
      this.challenge_id.performValidation();
      this.challenge_description.performValidation();
      this.start_date.performValidation();
      this.end_date.performValidation();
      if (!this.challenge_id.valid ||
        !this.challenge_description.valid ||
        !this.start_date.valid ||
        !this.end_date.valid) {
        this.actionForm.valid = false;
      }
    }

    return this.actionForm.valid;
  }

  loadJsonSchema(typeAction: SelectItem, appTypeActionFull?: AuditRulesType) {
    this.amazonOption = [];
    this.kafkaOption = [];
    this.magnewsOption = [];
    this.pushOption = [];
    this.kncRestOption = [];
    var actionRuleTypeIndex = this.actionsType.findIndex(f => f.id === typeAction.value);
    this.rulesService.getJsonFormSchema('action', this.ui_mode, typeAction.value).subscribe(resSchema => {
      if (resSchema) {
        var self = this;
        this.rulesService.getTemplateById(resSchema.template_id).subscribe(resTemplate => {
          if (resTemplate) {
            var newSchema = this.rulesService.getPreparedFormSchemasActions(resTemplate);
            self.formSchema = null;
            setTimeout(function () {
              self.formSchema = newSchema.properties.action;
              newSchema.mode = self.schemaMode;
              self.formSchemaChanged.emit(newSchema);
              var self2 = self;
              console.log(self.formSchema);
              setTimeout(function () {
                //self2.ready.form = true;
                //self2.enableConfirmButton.emit(true);
                // Controllo se selectedRule e description sono definiti

                let abc = self2.actionsType[actionRuleTypeIndex];
                // Logica per gestire il caso 'Cluster'
                if (abc.code === "cluster") {
                  self2.show.cluster = true;
                  self2.show.acm = false;
                  self2.show.amazon = false;
                  self2.show.kafka = false;
                  self2.show.magnews = false;
                  self2.show.kncRest = false;
                  self2.show.push = false;
                  self2.show.custMovement = false;
                  if (appTypeActionFull) { //spostato qui per problemi di rendering
                    self2.setFormFieldAfterLoadJson(typeAction, appTypeActionFull);
                  }
                } else if (abc.code === "amazon") {
                  self2.show.cluster = false;
                  self2.show.acm = false;
                  self2.show.amazon = true;
                  self2.show.kafka = false;
                  self2.show.magnews = false;
                  self2.show.kncRest = false;
                  self2.show.push = false;
                  self2.show.custMovement = false;
                  self2.amazonOption.push({ label: self2.translate.instant('common.select_something'), value: null });
                  self2.rulesService.getActionExternalList(typeAction.value).subscribe(res => {
                    res.forEach(r => {
                      self2.amazonOption.push({ label: `${r.description}`, value: r.id })
                    });
                    if (appTypeActionFull) { //spostato qui per problemi di rendering
                      self2.setFormFieldAfterLoadJson(typeAction, appTypeActionFull);
                    }
                  });
                } else if (abc.code === "kafka") {
                  self2.show.cluster = false;
                  self2.show.acm = false;
                  self2.show.amazon = false;
                  self2.show.kafka = true;
                  self2.show.magnews = false;
                  self2.show.kncRest = false;
                  self2.show.push = false;
                  self2.show.custMovement = false;
                  self2.kafkaOption.push({ label: self2.translate.instant('common.select_something'), value: null });
                  self2.rulesService.getActionExternalList(typeAction.value).subscribe(res => {
                    res.forEach(r => {
                      self2.kafkaOption.push({ label: `${r.description}`, value: r.id })
                    });
                    if (appTypeActionFull) {
                      self2.setFormFieldAfterLoadJson(typeAction, appTypeActionFull);
                    }
                  });
                } else if (abc.code === "magnews") {
                  self2.show.cluster = false;
                  self2.show.acm = false;
                  self2.show.amazon = false;
                  self2.show.kafka = false;
                  self2.show.magnews = true;
                  self2.show.kncRest = false;
                  self2.show.push = false;
                  self2.show.custMovement = false;
                  self2.magnewsOption.push({ label: self2.translate.instant('common.select_something'), value: null });
                  self2.rulesService.getActionExternalList(typeAction.value).subscribe(res => {
                    res.forEach(r => {
                      self2.magnewsOption.push({ label: `${r.description}`, value: r.id })
                    });
                    if (appTypeActionFull) {
                      self2.setFormFieldAfterLoadJson(typeAction, appTypeActionFull);
                    }
                  });
                } else if (abc.code === "acm") {
                  self2.show.cluster = false;
                  self2.show.acm = true;
                  self2.show.amazon = false;
                  self2.show.kafka = false;
                  self2.show.magnews = false;
                  self2.show.kncRest = false;
                  self2.show.push = false;
                  self2.show.custMovement = false;
                  if (appTypeActionFull) { //spostato qui per problemi di rendering
                    self2.setFormFieldAfterLoadJson(typeAction, appTypeActionFull);
                  }
                } else if (abc.code === "push") {
                  self2.show.cluster = false;
                  self2.show.acm = false;
                  self2.show.amazon = false;
                  self2.show.kafka = false;
                  self2.show.magnews = false;
                  self2.show.kncRest = false;
                  self2.show.push = true;
                  self2.show.custMovement = false;
                  self2.pushOption.push({ label: self2.translate.instant('common.select_something'), value: null });
                  self2.rulesService.getActionExternalList(typeAction.value).subscribe(res => {
                    res.forEach(r => {
                      self2.pushOption.push({ label: `${r.description}`, value: r.id })
                    });
                    if (appTypeActionFull) {
                      self2.setFormFieldAfterLoadJson(typeAction, appTypeActionFull);
                    }
                  });
                } else if (abc.code === "knc-rest-LinkClu") {
                  self2.show.cluster = false;
                  self2.show.acm = false;
                  self2.show.amazon = false;
                  self2.show.kafka = false;
                  self2.show.magnews = false;
                  self2.show.kncRest = true;
                  self2.show.push = false;
                  self2.show.custMovement = false;
                  self2.kncRestOption.push({ label: self2.translate.instant('common.select_something'), value: null });
                  self2.rulesService.getActionExternalList(typeAction.value).subscribe(res => {
                    res.forEach(r => {
                      self2.kncRestOption.push({ label: `${r.description}`, value: r.id })
                    });
                    if (appTypeActionFull) {
                      self2.setFormFieldAfterLoadJson(typeAction, appTypeActionFull);
                    }
                  });
                } else if (abc.code === "cust_movement") {
                  self2.show.cluster = false;
                  self2.show.acm = false;
                  self2.show.amazon = false;
                  self2.show.kafka = false;
                  self2.show.magnews = false;
                  self2.show.kncRest = false;
                  self2.show.push = false;
                  self2.show.custMovement = true;
                  if (appTypeActionFull) {
                    self2.setFormFieldAfterLoadJson(typeAction, appTypeActionFull);
                  }
                } else {
                  self2.show.cluster = false;
                  self2.show.acm = false;
                  self2.show.amazon = false;
                  self2.show.kafka = false;
                  self2.show.magnews = false;
                  self2.show.custMovement = false;
                  self2.show.push = true;
                  self2.show.kncRest = false;
                }

              }, 100)
            }, 100);
          } else {
            //caso non viene restituito ILTEMPLATE, devi fermarti (da gestire)!
            this.formSchemaChanged.emit(null);
            this.srvMessage.add({
              severity: 'error',
              summary: this.translate.instant('common.error'),
              detail: this.translate.instant('common.no_template_schema')
            });
          }
        });
      }
      else {
        //caso non viene restituito schema, devi fermarti (da gestire)!
        this.formSchemaChanged.emit(null);
        this.srvMessage.add({
          severity: 'error',
          summary: this.translate.instant('common.error'),
          detail: this.translate.instant('common.no_template_schema')
        });
      }
    });
  }

  async validaForms() {

    let validationAction = await this.performValidationAction();
    if (!validationAction) {
      return;
    }
    //se tutto è giusto procedi al salvataggio
    this.saveAuditRuleInstanceObject();
  }

  performSaveNewAuditRuleInstance() {
    this.rulesService.saveAuditRuleGlobalObject(this.auditRuleObject).subscribe(res => {
      if (res) {
        this.auditRuleObject = res;
        this.srvMessage.add({
          severity: 'success',
          summary: this.srvTranslate.instant('common.success'), // Usa la traduzione per "Success"
          detail: this.srvTranslate.instant('audit.operation_successful')
        });
        this.closePopUpDialog();
      } else {
        this.srvMessage.add({
          severity: 'error',
          summary: this.srvTranslate.instant('common.error'),
          detail: this.srvTranslate.instant('audit.genericActionError')
        });
        this.closePopUpDialog();
      }
    }, error => {
      console.error("errore aggiunta dettagolio regola")
      this.auditRuleObject.auditRuleDtl.pop();
      this.closePopUpDialog();
    });

  }

  performUpdateAuditRuleInstance() {
    this.rulesService.updateAuditRuleGlobalObject(this.auditRuleObject).subscribe(res => {

      if (res) {
        //self.ui_mode.infoBase = this.rulesService.ui_modes.EDIT;
        // self.actionListTable.refresh();
        this.auditRuleObject = res;
        this.srvMessage.add({
          severity: 'success',
          summary: this.srvTranslate.instant('common.success'), // Usa la traduzione per "Success"
          detail: this.srvTranslate.instant('audit.operation_successful')
        });
        this.closePopUpDialog();
      } else {
        this.auditRuleObject.auditRuleDtl.pop();
        this.srvMessage.add({
          severity: 'error',
          summary: this.srvTranslate.instant('common.error'),
          detail: this.srvTranslate.instant('audit.genericActionError')
        });
        this.closePopUpDialog();

      }
    }, error => {
      console.error("errore aggiunta dettagolio regola")
      this.auditRuleObject.auditRuleDtl.pop();
      this.closePopUpDialog();
    });

  }
  updateAuditRuleGlobalObject() {
    //fix perchè be manda oggetto nella get dell'oggettone
    this.auditRuleObject.auditRuleDtl.forEach(element => {
      if (element.audit_action_type_id && element.audit_action_type_id.id) {
        let app: any = element.audit_action_type_id.id;
        element.audit_action_type_id = app;
      }
    })

    this.auditRuleObject.auditRuleCondition.forEach(element => {
      if (element.audit_rules_condition_type_id && element.audit_rules_condition_type_id.id) {
        let app: any = element.audit_rules_condition_type_id.id;
        element.audit_rules_condition_type_id = app;
      }
    })


    this.ruleDtlIdCombo.description = this.descr_rule.nativeElement.value;
    this.ruleDtlIdCombo.dt_date_end = this.getDateStringDBFromDate(this.formGroup.get('date_end').value);
    this.ruleDtlIdCombo.dt_date_start = this.getDateStringDBFromDate(this.formGroup.get('date_start').value);
    this.ruleDtlIdCombo.audit_action_type_id = this.selectedRuleAction;

    if (this.show.acm) {
      this.ruleDtlIdCombo.acm_id = this.fieldModel.acm.value;
      this.ruleDtlIdCombo.acm_action_value = this.fieldModel.acm_val;
      this.ruleDtlIdCombo.reason_id = this.fieldModel.acm_reason.value;
      this.ruleDtlIdCombo.cluster_date_end = null;
      this.ruleDtlIdCombo.cluster_date_start = null;
      this.ruleDtlIdCombo.cluster_head_id = null
      this.ruleDtlIdCombo.flg_cluster_add = null
      this.ruleDtlIdCombo.audit_action_external_id = null;
    } else if (this.show.cluster) {
      this.ruleDtlIdCombo.cluster_date_end = this.getDateStringDBFromDate(this.fieldModel.cluster_end)
      this.ruleDtlIdCombo.cluster_date_start = this.getDateStringDBFromDate(this.fieldModel.cluster_start)
      this.ruleDtlIdCombo.cluster_head_id = this.fieldModel.cluster.value;
      this.ruleDtlIdCombo.flg_cluster_add = this.fieldModel.cluster_add ? "1" : "0";
      this.ruleDtlIdCombo.acm_id = null;
      this.ruleDtlIdCombo.acm_action_value = null;
      this.ruleDtlIdCombo.reason_id = null;
      this.ruleDtlIdCombo.audit_action_external_id = null;
    } else if (this.show.kafka) {
      this.ruleDtlIdCombo.audit_action_external_id = this.fieldModel.kafka.value;
      this.ruleDtlIdCombo.acm_id = null;
      this.ruleDtlIdCombo.acm_action_value = null;
      this.ruleDtlIdCombo.reason_id = null;
      this.ruleDtlIdCombo.cluster_date_end = null;
      this.ruleDtlIdCombo.cluster_date_start = null;
      this.ruleDtlIdCombo.cluster_head_id = null
      this.ruleDtlIdCombo.flg_cluster_add = null
    } else if (this.show.magnews) {
      this.ruleDtlIdCombo.audit_action_external_id = this.fieldModel.magnews.value;
      this.ruleDtlIdCombo.acm_id = null;
      this.ruleDtlIdCombo.acm_action_value = null;
      this.ruleDtlIdCombo.reason_id = null;
      this.ruleDtlIdCombo.cluster_date_end = null;
      this.ruleDtlIdCombo.cluster_date_start = null;
      this.ruleDtlIdCombo.cluster_head_id = null
      this.ruleDtlIdCombo.flg_cluster_add = null
    } else if (this.show.amazon) {
      this.ruleDtlIdCombo.audit_action_external_id = this.fieldModel.amazon.value;
      this.ruleDtlIdCombo.acm_id = null;
      this.ruleDtlIdCombo.acm_action_value = null;
      this.ruleDtlIdCombo.reason_id = null;
      this.ruleDtlIdCombo.cluster_date_end = null;
      this.ruleDtlIdCombo.cluster_date_start = null;
      this.ruleDtlIdCombo.cluster_head_id = null
      this.ruleDtlIdCombo.flg_cluster_add = null
    } else if (this.show.kncRest) {
      this.ruleDtlIdCombo.cluster_date_end = this.getDateStringDBFromDate(this.fieldModel.cluster_end)
      this.ruleDtlIdCombo.cluster_date_start = this.getDateStringDBFromDate(this.fieldModel.cluster_start)
      this.ruleDtlIdCombo.cluster_head_id = this.fieldModel.cluster.value;
      this.ruleDtlIdCombo.flg_cluster_add = this.fieldModel.cluster_add ? "Y" : "N";
      this.ruleDtlIdCombo.audit_action_external_id = this.fieldModel.kncRest.value;
      this.ruleDtlIdCombo.acm_id = null;
      this.ruleDtlIdCombo.acm_action_value = null;
      this.ruleDtlIdCombo.reason_id = null;
    } else if (this.show.custMovement) {
      this.ruleDtlIdCombo.condition_entity_id = this.fieldModel.challenge_id;
      this.ruleDtlIdCombo.challenge_description = this.fieldModel.challenge_description;
      this.ruleDtlIdCombo.start_date = this.getDateStringDBFromDate(this.fieldModel.start_date);
      this.ruleDtlIdCombo.end_date = this.getDateStringDBFromDate(this.fieldModel.end_date);
    } else {
      //caso in cui non abbiamo messo action type...possibile?
      //se non possibile bisogna bloccare o quanto meno disabilitare il bottone salva
      this.formSchemaChanged.emit(null);
      this.srvMessage.add({
        severity: 'error',
        summary: this.translate.instant('common.error'),
        detail: this.translate.instant('audit.noDetailsCompiled')
      });
      return;
    }

    const index = this.auditRuleObject.auditRuleDtl.findIndex(item => item.id === this.ruleDtlIdCombo.id);
    if (index !== -1) {
      this.auditRuleObject.auditRuleDtl[index] = this.ruleDtlIdCombo; // Assign a new value to the found index
    }
  }


  saveNewAuditRuleGlobalObject() {
    this.auditRuleObject.auditRuleDtl.forEach(element => {
      if (element.audit_action_type_id && element.audit_action_type_id.id) {
        let app: any = element.audit_action_type_id.id;
        element.audit_action_type_id = app;
      }
    })

    this.auditRuleObject.auditRuleCondition.forEach(element => {
      if (element.audit_rules_condition_type_id && element.audit_rules_condition_type_id.id) {
        let app: any = element.audit_rules_condition_type_id.id;
        element.audit_rules_condition_type_id = app;
      }
    })

    let appRuleDtl = new AuditRuleDtl();

    appRuleDtl.audit_rule_id = this.auditRuleObject.rule.id;
    appRuleDtl.description = this.descr_rule.nativeElement.value;
    appRuleDtl.dt_date_end = this.getDateStringDBFromDate(this.formGroup.get('date_end').value);
    appRuleDtl.dt_date_start = this.getDateStringDBFromDate(this.formGroup.get('date_start').value);
    appRuleDtl.audit_action_type_id = this.selectedRuleAction;

    if (this.show.acm) {
      appRuleDtl.acm_id = this.fieldModel.acm.value;
      appRuleDtl.acm_action_value = this.fieldModel.acm_val;
      appRuleDtl.reason_id = this.fieldModel.acm_reason.value;

    } else if (this.show.cluster) {
      appRuleDtl.cluster_date_end = this.getDateStringDBFromDate(this.fieldModel.cluster_end)
      appRuleDtl.cluster_date_start = this.getDateStringDBFromDate(this.fieldModel.cluster_start)
      appRuleDtl.cluster_head_id = this.fieldModel.cluster.value;
      appRuleDtl.flg_cluster_add = this.fieldModel.cluster_add ? "1" : "0";

    } else if (this.show.kafka) {
      appRuleDtl.audit_action_external_id = this.fieldModel.kafka.value;

    } else if (this.show.magnews) {
      appRuleDtl.audit_action_external_id = this.fieldModel.magnews.value;
    } else if (this.show.amazon) {
      appRuleDtl.audit_action_external_id = this.fieldModel.amazon.value;
    } else if (this.show.kncRest) {
      appRuleDtl.cluster_date_end = this.getDateStringDBFromDate(this.fieldModel.cluster_end)
      appRuleDtl.cluster_date_start = this.getDateStringDBFromDate(this.fieldModel.cluster_start)
      appRuleDtl.cluster_head_id = this.fieldModel.cluster.value;
      appRuleDtl.flg_cluster_add = this.fieldModel.cluster_add ? "1" : "0";
      appRuleDtl.audit_action_external_id = this.fieldModel.kncRest.value;
    } else if (this.show.custMovement) {
      appRuleDtl.condition_entity_id = this.fieldModel.challenge_id;
      appRuleDtl.challenge_description = this.fieldModel.challenge_description;
      appRuleDtl.start_date = this.getDateStringDBFromDate(this.fieldModel.start_date);
      appRuleDtl.end_date = this.getDateStringDBFromDate(this.fieldModel.end_date);
    } else {
      //caso in cui non abbiamo messo action type...possibile?
      //se non possibile bisogna bloccare o quanto meno disabilitare il bottone salva
      this.formSchemaChanged.emit(null);
      this.srvMessage.add({
        severity: 'error',
        summary: this.translate.instant('common.error'),
        detail: this.translate.instant('audit.noDetailsCompiled')
      });
      return;
    }
    this.auditRuleObject.auditRuleDtl.push(appRuleDtl);
  }

  saveAuditRuleInstanceObject() {


    //salvo solo il dettaglio nella regola
    if (this.auditRuleDtEditlId && this.auditRuleDtEditlId > 0) {
      this.updateAuditRuleGlobalObject();
    } else {
      this.saveNewAuditRuleGlobalObject();
    }

    if (this.auditRuleObject && this.auditRuleObject.rule && this.auditRuleObject.rule.id) {
      this.performUpdateAuditRuleInstance();
    } else {
      this.performSaveNewAuditRuleInstance();
    }
  }

  closeAddNewAction() {
    this.validaForms();

  }

  onClickClose() {
    if (this.isPopUp) {
      this.isPopUp = false;
      this.closePopUp.emit();
    }
  }
  onChangeClusterActionAdd(switchValue: boolean) {
    this.fieldModel.cluster_add = switchValue;
    this.fieldModel.cluster_delete = !switchValue;

  }
  onChangeClusterActionDelete(switchValue: boolean) {
    this.fieldModel.cluster_add = !switchValue;
    this.fieldModel.cluster_delete = switchValue;

  }
  onChangeAcm(acm: SelectItem, ruleTable?: AuditRuleDtl) {
    // Svuota la lista prima di popolarla
    this.listReasonsFiltered = [];
    //this.listReasonsFiltered.push({ value: null, label: 'null' });

    const params = [{ key: 'limit', value: '9999999' }];
    params.push({ key: 'flg_state', value: '0' });
    let acmTypeId = this.acmListFull.filter((f) => f.id === acm.value)[0].acm_type_id;

    this.acmTypeHasReasonService.getFromAcmType(acmTypeId, params).subscribe(resp => {
      // Controlla se ci sono dati nella risposta
      if (resp.data && resp.data.length > 0) {
        for (const reason of resp.data) {
          this.listReasonsFiltered.push({
            value: reason.reason_id,
            label: reason.reasonCode + " | " + reason.reasonDescription
          });
        }
        var self = this;
        setTimeout(function () {

          if (ruleTable) {
            self.fieldModel.acm = acm;
            self.fieldModel.acm_reason = self.listReasonsFiltered.find(f => f.value === ruleTable.reason_id); //ruleTable.reason_id;
          }
        }, 100)
      }
      // Log per verificare se la lista è stata aggiornata correttamente
      console.log(this.listReasonsFiltered);
    });
  }

  initForm() {
    this.formGroup = this.fb.group({
      date_end: [null, Validators.required],
      date_start: [null, Validators.required]
    });
  }

  setFormField() {
    this.ruleDtlIdCombo = this.auditRuleObject.auditRuleDtl.find(f => f.id === this.auditRuleDtEditlId);
    let appTypeAction: SelectItem;
    let appTypeActionFull: AuditRulesType;
    if (this.ruleDtlIdCombo.audit_action_type_id && this.ruleDtlIdCombo.audit_action_type_id.id) {//nel caso di edit e sono nel primo salvataggio partendo dalle regole mi arriva un oggetto AuditRuleDtl e non l'id
      appTypeAction = this.actionsTypeCombo.find(f => f.value === this.ruleDtlIdCombo.audit_action_type_id.id);
      appTypeActionFull = this.actionsType.find(f => f.id === (this.ruleDtlIdCombo.audit_action_type_id.id));
    } else {
      appTypeAction = this.actionsTypeCombo.find(f => f.value === this.ruleDtlIdCombo.audit_action_type_id);
      appTypeActionFull = this.actionsType.find(f => f.id === (this.ruleDtlIdCombo.audit_action_type_id as any));
    }
    this.loadJsonSchema(appTypeAction, appTypeActionFull);
  }

  private setFormFieldAfterLoadJson(appTypeAction: SelectItem, appTypeActionFull: AuditRulesType) {
    let ruleTable = this.auditRuleObject.auditRuleDtl.find(f => f.id === this.auditRuleDtEditlId);
    this.descr_rule.nativeElement.value = ruleTable.description;
    this.selectedRuleAction = appTypeAction.value;
    var self = this;
    setTimeout(function () {
      self.formGroup = self.fb.group({
        date_start: self.ruleDtlIdCombo.dt_date_start
          ? [self.getDateFromStringToSTringCalendar(self.ruleDtlIdCombo.dt_date_start), Validators.required] : ['', Validators.required],
        date_end: self.ruleDtlIdCombo.dt_date_end
          ? [self.getDateFromStringToSTringCalendar(self.ruleDtlIdCombo.dt_date_end), Validators.required] : ['', Validators.required],
      });
      if (ruleTable.acm_id) {
        self.onChangeAcm(self.acmList.find(f => f.value === ruleTable.acm_id), ruleTable); //ruleTable.acm_id;
        self.fieldModel.acm_val = ruleTable.acm_action_value;
        self.fieldModel.acm = self.acmList.find(f => f.value === ruleTable.acm_id);

      }
      if (ruleTable.audit_action_external_id) {
        self.fieldModel.kafka = appTypeActionFull.code == "kafka" ? self.kafkaOption.find(f => f.value === ruleTable.audit_action_external_id) : null;
        self.fieldModel.amazon = appTypeActionFull.code == "amazon" ? self.amazonOption.find(f => f.value === ruleTable.audit_action_external_id) : null; //ruleTable.audit_action_external_id : null;
        self.fieldModel.magnews = appTypeActionFull.code == "magnews" ? self.magnewsOption.find(f => f.value === ruleTable.audit_action_external_id) : null; //ruleTable.kafka_id;
        self.fieldModel.push = appTypeActionFull.code == "push" ? self.pushOption.find(f => f.value === ruleTable.audit_action_external_id) : null; //ruleTable.kafka_id;
        self.fieldModel.kncRest = appTypeActionFull.code == "knc-rest-LinkClu" ? self.kncRestOption.find(f => f.value === ruleTable.audit_action_external_id) : null; //ruleTable.kafka_id;
      }

      if (ruleTable.cluster_head_id) {
        self.fieldModel.cluster_start = self.getDateFromStringToSTringCalendar(ruleTable.cluster_date_start);
        self.fieldModel.cluster_end = self.getDateFromStringToSTringCalendar(ruleTable.cluster_date_end);
        self.fieldModel.cluster_add = (ruleTable.flg_cluster_add == "Y" || ruleTable.flg_cluster_add == "1");
        self.fieldModel.cluster_delete = !(ruleTable.flg_cluster_add == "Y" || ruleTable.flg_cluster_add == "1");
        self.fieldModel.cluster = self.clusterOption.find(f => f.value == ruleTable.cluster_head_id);
      }

      if (appTypeActionFull.code === "cust_movement") {
        self.fieldModel.challenge_id = ruleTable.acm_action_value;
        self.fieldModel.challenge_description = self.auditRuleObject.rule.description;
        self.fieldModel.start_date = self.getDateFromStringToSTringCalendar(ruleTable.start_date);
        self.fieldModel.end_date = self.getDateFromStringToSTringCalendar(ruleTable.end_date);
      }

    }, 300);
  }

  getDateStringDBFromDate(date: Moment): string | null {
    // let formattedStartDate = moment(date).format('DD-MM-YYYY');
    const dataConvertita = moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD');
    return dataConvertita;
  }

  getDateFromStringToSTringCalendar(date: string): string | null {
    let formattedStartDate = moment(date).format('DD/MM/YYYY');
    return formattedStartDate;
  }

  get isCustMovementEdit(): boolean {
    return this.show.custMovement && !!(this.auditRuleDtEditlId && this.auditRuleDtEditlId > 0);
  }

  get effectiveClusterOption(): SelectItem[] {
    const isEdit = this.auditRuleDtEditlId && this.auditRuleDtEditlId > 0;
    return isEdit ? this.clusterOption : (this.clusterOptionActive || this.clusterOption);
  }

  closePopUpDialog() {
    this.isPopUp = false;
    this.closePopUp.emit(this.auditRuleObject);
    this.conditionObjectChanged.emit(this.auditRuleObject);

  }


}



// WEBPACK FOOTER //
// ./src/app/views/audit/rules/add-rule/audit-action/audit-new-action/audit-new-action.component.ts